<div class="pie-card">
  
  <div class="pie-title">{{ title }}</div>
  <div class="pie-separator"></div>

  <div class="pie-wrapper">

    <!-- Pie Canvas -->
    <canvas #canvas width="280" height="280"></canvas>

    <!-- Legend -->
    <div class="pie-legend">
      <div class="legend-title">Legend</div>

      <div class="legend-item" *ngFor="let item of data; let i = index">
        <span class="legend-color" [style.background]="colorScheme[i % colorScheme.length]"></span>
        <span class="legend-label">
          {{ item.name }}
        </span>
      </div>
    </div>

  </div>

</div>
